export const rockerEmployerList = 'rockerboxList';
export const rockerboxEmployerKey = 'rockerboxEmployer';
export const rockerboxApplicantKey = 'rockerboxApplicatntList';
export const rockerboxDocumentsKey = 'rockerboxDocumentsList';
export const applicationsCountsKey = 'applicationsCounts';
export const errorMessage = 'Sorry, something went wrong';